selectCheckboxes();

function selectCheckboxes(){

    //console.log('check');

    $('.js-select-checkboxes').on('click', function(){

        //console.log('clicked');
         $(".checkbox").prop('checked', $(this).prop("checked"));
        //console.log($(".checkbox"));
    });

    //".checkbox" change
    $('.checkbox').change(function(){
        //uncheck "select all", if one of the listed checkbox item is unchecked
        if(false == $(this).prop("checked")){ //if this item is unchecked
            $(".js-select-checkboxes").prop('checked', false); //change "select all" checked status to false
        }
        //check "select all" if all checkbox items are checked
        if ($('.checkbox:checked').length == $('.checkbox').length ){
            $(".js-select-checkboxes").prop('checked', true);
        }
    });

};